if ($(window).width() < 768) {

    $(window).scroll(function() { 
      
        // code for showing bottom mobile menu
        if ($(this).scrollTop()>20)
         {
            $('#mhp-container').addClass("show-menu");
           $('#mhp-embed-container').addClass("show-menu");
           
         }
        else
         {
            $('#mhp-container').removeClass("show-menu");
           $('#mhp-embed-container').removeClass("show-menu");
         }
    
    
    
    
    
        // code for filters - collection page
        var headerHeight = $('.site-header-main').innerHeight();
        var gridHeight = $('#gf-grid').innerHeight();
    
        var grid = $('#gf-grid');
        if (grid.length) {
          var contentGrid = grid.offset().top;
        
          if ($(this).scrollTop() >= (contentGrid - headerHeight)  &&  ($(this).scrollTop() <= gridHeight))
           {
              $('.mobile-sort-filter').addClass('fixed');
           }
          else
           {
            $('.mobile-sort-filter').removeClass('fixed');
           }	
        }
    
      
    		
        // code for Add to cart and subscribe button - product page
        if($(window).scrollTop() >= ($('.pro_check_avail').offset().top) ){
            $('body').addClass('addclass');
            $('.fixed-bottom-mobile').addClass("show-fixed");
            $('#mhp-container').addClass("hide-menu");
            $('.cstm-inh-section .recurpay__widget .recurpay__action').addClass("show-subscribe-btn");
        }
        else 
        {
            $('body').removeClass('addclass');
            $('.fixed-bottom-mobile').removeClass("show-fixed");
            $('#mhp-container').removeClass("hide-menu");
            $('.cstm-inh-section .recurpay__widget .recurpay__action').removeClass("show-subscribe-btn");
        }
    
    
    
     });

}

     
   
    


